import { Income } from "../models/Income";
import { Comment } from "../models/Comment";
import api from "./api";
import { clean } from "../utils/utils";

const PATH = "/api/v1/incomes";

export const IncomeService = {
  async getIncomes(matterId: string): Promise<Income[]> {
    const res = await api.get(PATH, {
      params: { matterId },
    });
    return res.data?.data ?? [];
  },

  async getIncome(incomeId: string): Promise<Income> {
    const res = await api.get(`${PATH}/${incomeId}`);
    return res.data?.data;
  },

  async createIncome(income: Partial<Income>): Promise<string> {
    const res = await api.post(PATH, clean(income));
    return res.data?.data?._id;
  },

  async updateIncome(
    incomeId: string,
    incomeData: Partial<Omit<Income, "_id">>,
  ): Promise<void> {
    await api.put(`${PATH}/${incomeId}`, incomeData);
  },

  async deleteIncome(matterId: string, incomeId: string): Promise<void> {
    await api.delete(`${PATH}/${incomeId}`, {
      params: { matterId },
    });
  },

  async getComments(incomeId: string): Promise<Comment[]> {
    const res = await api.get(`${PATH}/${incomeId}/comments`);
    return res.data?.data ?? [];
  },
};
